import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * Callout — a restrained left-ruled aside. The tint is deliberately faint
 * (~6%) so the block reads as an emphasis, not an alert. `finding` uses the
 * brand accent; `info` uses the theme info token.
 */
const VARIANTS = {
  finding: 'border-l-[3px] border-l-[var(--report-accent)] bg-[var(--report-accent)]/[0.06]',
  info: 'border-l-[3px] border-l-info bg-info/[0.06]',
} as const

export function Callout({
  variant = 'finding',
  children,
}: {
  variant?: keyof typeof VARIANTS
  children: ReactNode
}) {
  return (
    <aside
      className={cn(
        'rounded-r-lg py-3 pl-4 pr-5 text-sm leading-relaxed text-foreground break-inside-avoid',
        VARIANTS[variant],
      )}
    >
      {children}
    </aside>
  )
}
